module.exports = __webpack_public_path__ + "media/bootstrap-icons/tv-fill-0d32faf8.svg";